import { useMemo } from "react";

import { ROUTES_BASE, ROUTES_PRIMARY, ROUTES_WORKSPACE } from "shared/Routes";
import { useRouteMatchOrTwoFactorPrompt } from "shared/useRouteMatchOrTwoFactorPrompt";

import { CohortsNavigation } from "./CohortsNavigation/CohortsNavigation";
import { SettingsNavigation } from "./SettingsNavigation/SettingsNavigation";

export const useSecondaryNavigation = () => {
    const matchCohortsPath = useRouteMatchOrTwoFactorPrompt({
        path: [
            ROUTES_PRIMARY.patientsLists,
            ROUTES_BASE.integratedClinicListsAll,
            ROUTES_WORKSPACE.batchMessageTrustSentMessages,
        ],
    });
    const matchManagePath = useRouteMatchOrTwoFactorPrompt({
        path: [ROUTES_PRIMARY.workspaceSettings, ROUTES_PRIMARY.account],
    });

    const navigationMenu = useMemo(() => {
        if (matchCohortsPath) {
            return <CohortsNavigation />;
        } else if (matchManagePath) {
            return <SettingsNavigation />;
        } else {
            return null;
        }
    }, [matchCohortsPath, matchManagePath]);

    return navigationMenu;
};
